import { loadablePage } from 'utils/loadable'

const GroupsAsync = loadablePage(() => import(/* webpackChunkName: "groups" */ './Groups'))

export default GroupsAsync
